import React from "react";
import { Link } from "react-router-dom";
import { Compass, Sparkles, Ticket, Heart, Briefcase, Users, ArrowUpRight } from "lucide-react";

// 6 quick-jump tiles into the app's core sections.
// Labels intentionally match the EXISTING nav language (Match, VIP, AI Gallery, etc.)
// so there's no vocabulary drift between nav, tiles and pages.
const TILES = [
  {
    to: "/#events-grid", testId: "tile-discover", label: "Discover",
    sub: "Find what's happening near you", Icon: Compass,
    from: "from-emerald-500/30", accent: "bg-lime", text: "text-lime",
    ring: "hover:border-lime/60",
    img: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=800&auto=format&fit=crop&q=60",
  },
  {
    to: "/ai-gallery", testId: "tile-ai-gallery", label: "AI Gallery",
    sub: "Your event photos, auto-tagged", Icon: Sparkles,
    from: "from-purple/30", accent: "bg-purple", text: "text-purple",
    ring: "hover:border-purple/60",
    img: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800&auto=format&fit=crop&q=60",
  },
  {
    to: "/profile", testId: "tile-tickets", label: "My Tickets",
    sub: "All your passes in one place", Icon: Ticket,
    from: "from-magenta/30", accent: "bg-magenta", text: "text-magenta",
    ring: "hover:border-magenta/60",
    img: "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=800&auto=format&fit=crop&q=60",
  },
  {
    to: "/clubvip", testId: "tile-match", label: "Match",
    sub: "Meet people going too", Icon: Heart,
    from: "from-skyx/30", accent: "bg-skyx", text: "text-skyx",
    ring: "hover:border-skyx/60",
    img: "https://images.unsplash.com/photo-1524368535928-5b5e00ddc76b?w=800&auto=format&fit=crop&q=60",
  },
  {
    to: "/organisers", testId: "tile-organisers", label: "For Organisers",
    sub: "Everything you need to make an event happen", Icon: Briefcase,
    from: "from-orangex/30", accent: "bg-orangex", text: "text-orangex",
    ring: "hover:border-orangex/60",
    img: "https://images.unsplash.com/photo-1531058020387-3be344556be6?w=800&auto=format&fit=crop&q=60",
  },
  {
    to: "/community", testId: "tile-community", label: "Community",
    sub: "The insider feed for real event people", Icon: Users,
    from: "from-lime/25", accent: "bg-white", text: "text-white",
    ring: "hover:border-white/60",
    img: "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=800&auto=format&fit=crop&q=60",
  },
];

export default function FeatureTiles() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-8" data-testid="home-feature-tiles">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {TILES.map(({ to, testId, label, sub, Icon, from, accent, text, ring, img }, i) => (
          <Link key={testId} to={to} data-testid={testId}
            style={{ animationDelay: `${i * 80}ms` }}
            className={`gz-rise group relative rounded-3xl overflow-hidden border border-white/10 ${ring} transition-all min-h-[190px] flex flex-col justify-between p-4`}>
            <img src={img} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-60 transition-opacity" />
            <div className={`absolute inset-0 bg-gradient-to-br ${from} to-black/85`} />
            <div className="relative">
              <div className={`w-10 h-10 rounded-2xl ${accent} text-ink grid place-items-center shadow-lg`}>
                <Icon className="w-5 h-5" strokeWidth={2.4} />
              </div>
            </div>
            <div className="relative">
              <div className="font-fancy text-2xl leading-none text-white">{label}</div>
              <div className="text-[11px] text-white/70 mt-1 leading-snug">{sub}</div>
              <div className={`mt-3 inline-flex items-center gap-1 text-[10px] font-mono font-bold uppercase tracking-widest ${text}`}>
                Open <ArrowUpRight className="w-3 h-3" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
